"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reduxPersist = require("redux-persist");

var _index = require("../index");

var _consts = require("../consts");

var _actions = require("../actions");

var _vehicle = require("../utils/vehicle");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  vehicles: null,
  currentIndustryType: null,
  currentBrand: null,
  //will be filled from getBrandTheme()
  currentId: null,
  currentYear: null,
  currentGroup: null,
  currentModel: null,
  currentProductType: null,
  currentProductSubtype: null,
  filter: {
    brand: _consts.FILTER.ALL,
    productType: _consts.FILTER.ALL
  },
  fetching: false,
  error: null
};
var rehydrateState = {
  vehicles: null,
  fetching: false,
  error: null
};

function compareVehicles(a, b) {
  var at = a.model || a.title;
  var bt = b.model || b.title;
  return at.localeCompare(bt);
}

function vehicle(state, action) {
  var _getConfig = (0, _index.getConfig)(),
      COMING_SOON_CONTENT = _getConfig.COMING_SOON_CONTENT;

  state = state || _objectSpread(_objectSpread({}, initialState), {}, {
    currentBrand: (0, _vehicle.getBrandTheme)()
  });

  switch (action.type) {
    case _actions.GET_VEHICLES_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentGroup: null,
        fetching: true,
        error: null
      });

    case _actions.GET_VEHICLES_SUCCESS:
      //TODO: remove hardcoded vehicles for Coming soon
      action.payload = [].concat(_toConsumableArray(action.payload.sort(compareVehicles)), _toConsumableArray(COMING_SOON_CONTENT));
      return _objectSpread(_objectSpread({}, state), {}, {
        vehicles: action.payload,
        fetching: false
      });

    case _actions.GET_VEHICLES_CANCEL:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetching: false
      });

    case _actions.GET_VEHICLES_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        vehicles: null,
        fetching: false,
        error: action.payload
      });

    case _actions.SET_VEHICLE_GROUP:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentGroup: action.payload
      });

    case _actions.SET_VEHICLE_MODEL:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentModel: action.payload
      });

    case _actions.SET_VEHICLE_ID:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentId: action.payload
      });

    case _actions.SET_INDUSTRY_TYPE:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentIndustryType: action.payload,
        // currentBrand: null, // current branding theme should stay as is until new one is selected
        currentId: null,
        currentModel: null,
        currentGroup: null,
        currentYear: null,
        currentProductType: null,
        currentProductSubtype: null,
        filter: {
          brand: _consts.FILTER.ALL,
          productType: _consts.FILTER.ALL
        }
      });

    case _actions.SET_VEHICLE_BRAND:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentBrand: action.payload,
        currentId: null,
        currentModel: null,
        currentGroup: null,
        currentYear: null,
        currentProductType: null,
        currentProductSubtype: null
      });

    case _actions.SET_VEHICLE_YEAR:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentYear: action.payload
      });

    case _actions.SET_VEHICLE_PRODUCT_TYPE:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentProductType: action.payload
      });

    case _actions.SET_VEHICLE_PROGRAM:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentYear: action.payload.year,
        currentModel: action.payload.model
      });

    case _actions.SET_VEHICLE_PRODUCT_SUBTYPE:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentProductSubtype: action.payload
      });

    case _actions.VEHICLES_RESET:
      return _objectSpread(_objectSpread({}, state), {}, {
        vehicles: null
      });

    case _actions.SET_FILTER:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          filter: action.payload
        });
      }

    case _reduxPersist.REHYDRATE:
      if (action.payload && action.payload.vehicle) return _objectSpread(_objectSpread(_objectSpread({}, state), action.payload.vehicle), rehydrateState);
      return state;

    default:
      return state;
  }
}

var _default = vehicle;
exports["default"] = _default;